











import { Component, Prop, Vue } from 'vue-property-decorator';
import { BSpinner } from 'bootstrap-vue';

@Component({ components: { BSpinner } })
export default class LoadingOverlay extends Vue {
  @Prop()
  public loading!: boolean;

  @Prop({ default: false })
  public hideContentTillLoaded!: boolean;

  public get showContent(): boolean {
    return !this.hideContentTillLoaded || !this.loading;
  }
}
